export default __webpack_public_path__ + "static/media/facturas_pagos.15beb322.jpg";